import React, { ComponentProps } from "react";

import { Button } from "@examspark/common-ui";
import { IconFeedbackLine } from "@examspark/common-ui/dist/components/icons";
import { Subject } from "@examspark/types";

import { useModal } from "../hooks/useModal";
import { useAppContext } from "../providers";

import FeedbackModal from "./FeedbackModal";

type Props = {
  showItemFeedbackHint?: boolean;
  condensed?: boolean;
  itemSubject?: Subject;
  itemId?: string;
} & ComponentProps<typeof Button>;

const FeedbackButton = (props: Props) => {
  const modal = useModal();
  const [appContext] = useAppContext();

  if (!appContext.app?.config?.feedbackOptions) {
    return null;
  }

  return (
    <>
      <Button
        title="Feedback"
        onClick={() => modal.open()}
        variant="outlined"
        {...props}
      >
        <IconFeedbackLine width="17" />
        {props.condensed ? "" : "Feedback"}
      </Button>
      <FeedbackModal
        appContext={appContext}
        showItemFeedbackHint={props.showItemFeedbackHint}
        options={appContext.app.config.feedbackOptions}
        itemSubject={props.itemSubject}
        itemId={props.itemId}
        {...modal.modalProps}
      />
    </>
  );
};

export default FeedbackButton;
